export default __webpack_public_path__ + "static/media/3120.35fcfad2.jpg";